import React from 'react';

const SuccessPage = () => {
    return (
        <div>
            Thanks! Payment Successful!
        </div>
    );
};

export default SuccessPage;